import {
  BarChart3,
  BookOpen,
  CreditCard,
  DollarSign,
  FileText,
  LayoutDashboard,
  Package,
  Receipt,
  ShieldCheck,
  Target,
  TrendingUp,
  Users,
} from "lucide-react";

export const navbarItems = [
  // ── Existing items (unchanged) ─────────────────────────────────────────────
  {
    id: "Dashboard",
    label: "Dashboard",
    icon: LayoutDashboard,
    module: "dashboard",
    path: "/dashboard",
    action: "view",
  },

  {
    id: "Pipeline",
    label: "Pipeline",
    icon: BarChart3,
    module: "pipeline",
    path: "/pipeline-analytics",
    action: "view",
  },

  {
    id: "lovable-leads",
    label: "Leads/Client",
    icon: Target,
    module: "client",
    path: "/leads",
    action: "list",
    // isLovable: true,
    // group: "Pipeline",
  },
  {
    id: "Client",
    label: "Clients",
    icon: Users,
    module: "clients",
    path: "/clients",
    action: "list",
  },

  {
    id: "lovable-opportunities",
    label: "Opportunities",
    icon: TrendingUp,
    module: "pipeline",
    path: "/opportunities",
    action: "view",
    isLovable: true,
    group: "Pipeline",
  },

  {
    id: "lovable-rfqs",
    label: "RFQs",
    icon: FileText,
    module: "rfqs",
    path: "/rfqs",
    action: "list",
    isLovable: true,
    group: "Quoting",
  },

  {
    id: "Policies",
    label: "Policies",
    icon: ShieldCheck,
    module: "policies",
    path: "/policies",
    action: "view",
  },

  //  {
  //   id: "lovable-account-plans",
  //   label: "Accounting",
  //   icon: ClipboardList,
  //   module: "clients",
  //   path: "/account-plans",
  //   action: "list",
  //   isLovable: true,
  //   group: "Clients",
  // },

  {
    id: "lovable-commissions",
    label: "Commissions",
    icon: DollarSign,
    module: "money",
    path: "/commissions",
    action: "view",
    isLovable: true,
    group: "Money",
  },

  {
    id: "lovable-payments",
    label: "Payments",
    icon: CreditCard,
    module: "money",
    path: "/payments",
    action: "view",
    isLovable: true,
    group: "Money",
  },

  //  {
  //   id: "lovable-trust-account",
  //   label: "Trust Account",
  //   icon: Landmark,
  //   module: "money",
  //   path: "/trust-account",
  //   action: "view",
  //   isLovable: true,
  //   group: "Money",
  // },

  {
    id: "lovable-tax",
    label: "Tax & Statutory",
    icon: Receipt,
    module: "money",
    path: "/tax",
    action: "view",
    isLovable: true,
    group: "Money",
  },

  {
    id: "lovable-knowledge",
    label: "Knowledge Library",
    icon: BookOpen,
    // "quotes" is a module the role has; "catalog" has no permission so the item would be hidden.
    module: "quotes",
    path: "/knowledge",
    action: "view",
    isLovable: true,
    group: "Catalog",
  },

  // ── Lovable: Clients group ─────────────────────────────────────────────────
  // {
  //   id: "insurer",
  //   label: "Insurers",
  //   icon: UserRoundCheck,
  //   path: "/insurers",
  //   module: "insurerconfig",
  //   action: "view",
  // },
  //  {
  //   id: "Settings",
  //   label: "Settings",
  //   icon: Cog,
  //   module: "settings",
  //   path: "/settings",
  //   action: "view",
  // },

  // {
  //   id: "Settings",
  //   label: "Tasks",
  //   icon: ShieldCheck,
  //   module: "settings",
  //   path: "/settings",
  //   action: "view",
  // },

  // ── Lovable: Catalog group ─────────────────────────────────────────────────
  // {
  //   id: "lovable-products",
  //   label: "Products",
  //   icon: Package,
  //   module: "catalog",
  //   path: "/products",
  //   action: "view",
  //   isLovable: true,
  //   group: "Catalog",
  // },
  // {
  //   id: "lovable-knowledge",
  //   label: "Knowledge Library",
  //   icon: BookOpen,
  //   module: "catalog",
  //   path: "/knowledge",
  //   action: "view",
  //   isLovable: true,
  //   group: "Catalog",
  // },

  // // ── Lovable: Quoting group ─────────────────────────────────────────────────

  // {
  //   id: "lovable-surveys",
  //   label: "Surveys",
  //   icon: ClipboardList,
  //   module: "quotes",
  //   path: "/surveys",
  //   action: "view",
  //   isLovable: true,
  //   group: "Quoting",
  // },

  // // {
  // //   id: "Quotes",
  // //   label: "Quotes",
  // //   icon: FileText,
  // //   module: "quotes",
  // //   path: "/quotes" ,
  // //   action: "view",
  // // },

  // {
  //   id: "Calls",
  //   label: "Call Log",
  //   icon: Phone,
  //   module: "calls",
  //   path: "/calls",
  //   action: "view",
  // },

  // {
  //   id: "API Configuration",
  //   label: "API Configuration",
  //   icon: Cog,
  //   module: "provider-service",
  //   path: "/api-configuration",
  //   action: "list",
  // },
  // {
  //   id: "Logs",
  //   label: "Logs",
  //   icon: FileText,
  //   module: "logs",
  //   path: "/logs",
  //   action: "view",
  // },

  // ── Lovable: Pipeline group ────────────────────────────────────────────────

  // {
  //   id: "lovable-pipeline-analytics",
  //   label: "Pipeline Analytics",
  //   icon: BarChart3,
  //   module: "pipeline",
  //   path: "/pipeline-analytics",
  //   action: "view",
  //   isLovable: true,
  //   group: "Pipeline",
  // },

  // ── Lovable: Policies group ────────────────────────────────────────────────
  // {
  //   id: "lovable-endorsements",
  //   label: "Endorsements",
  //   icon: ShieldCheck,
  //   module: "policies",
  //   path: "/endorsements",
  //   action: "view",
  //   isLovable: true,
  //   group: "Policies",
  // },
  // {
  //   id: "lovable-renewals",
  //   label: "Renewals",
  //   icon: RefreshCw,
  //   module: "policies",
  //   path: "/renewals",
  //   action: "view",
  //   isLovable: true,
  //   group: "Policies",
  // },
  // {
  //   id: "lovable-claims",
  //   label: "Claims",
  //   icon: AlertCircle,
  //   module: "policies",
  //   path: "/claims",
  //   action: "view",
  //   isLovable: true,
  //   group: "Policies",
  // },

  // // ── Lovable: Money group ───────────────────────────────────────────────────
  // {
  //   id: "lovable-payments",
  //   label: "Payments",
  //   icon: CreditCard,
  //   module: "money",
  //   path: "/payments",
  //   action: "view",
  //   isLovable: true,
  //   group: "Money",
  // },
  // {
  //   id: "lovable-trust-account",
  //   label: "Trust Account",
  //   icon: Landmark,
  //   module: "money",
  //   path: "/trust-account",
  //   action: "view",
  //   isLovable: true,
  //   group: "Money",
  // },

  // {
  //   id: "lovable-tax",
  //   label: "Tax & Statutory",
  //   icon: Receipt,
  //   module: "money",
  //   path: "/tax",
  //   action: "view",
  //   isLovable: true,
  //   group: "Money",
  // },

  // // ── Lovable: Network group ─────────────────────────────────────────────────
  // {
  //   id: "lovable-partners",
  //   label: "Partners & Sub-brokers",
  //   icon: Handshake,
  //   module: "network",
  //   path: "/partners",
  //   action: "view",
  //   isLovable: true,
  //   group: "Network",
  // },
  // {
  //   id: "lovable-api-partners",
  //   label: "API Partners",
  //   icon: Plug,
  //   module: "network",
  //   path: "/partners/api-partners",
  //   action: "view",
  //   isLovable: true,
  //   group: "Network",
  // },
  // {
  //   id: "lovable-insurers",
  //   label: "Insurer Panel",
  //   icon: Building2,
  //   module: "network",
  //   path: "/insurers",
  //   action: "view",
  //   isLovable: true,
  //   group: "Network",
  // },

  // // ── Lovable: Engagement group ──────────────────────────────────────────────
  // {
  //   id: "lovable-inbox",
  //   label: "Communications",
  //   icon: MessageSquare,
  //   module: "engagement",
  //   path: "/inbox",
  //   action: "view",
  //   isLovable: true,
  //   group: "Engagement",
  // },
  // {
  //   id: "lovable-client-portal",
  //   label: "Client Portal",
  //   icon: Globe,
  //   module: "engagement",
  //   path: "/client-portal",
  //   action: "view",
  //   isLovable: true,
  //   group: "Engagement",
  // },
  // {
  //   id: "lovable-mobile-preview",
  //   label: "Mobile App Preview",
  //   icon: Smartphone,
  //   module: "engagement",
  //   path: "/mobile-preview",
  //   action: "view",
  //   isLovable: true,
  //   group: "Engagement",
  // },
  // {
  //   id: "lovable-documents",
  //   label: "Documents",
  //   icon: FolderOpen,
  //   module: "engagement",
  //   path: "/documents",
  //   action: "view",
  //   isLovable: true,
  //   group: "Engagement",
  // },

  // // ── Lovable: Intelligence group ────────────────────────────────────────────
  // {
  //   id: "lovable-ai",
  //   label: "AI Co-pilot",
  //   icon: Bot,
  //   module: "intelligence",
  //   path: "/ai",
  //   action: "view",
  //   isLovable: true,
  //   group: "Intelligence",
  // },
  // {
  //   id: "lovable-reports",
  //   label: "Reports",
  //   icon: BarChart3,
  //   module: "intelligence",
  //   path: "/reports",
  //   action: "view",
  //   isLovable: true,
  //   group: "Intelligence",
  // },

  // // ── Lovable: Platform group ────────────────────────────────────────────────
  // {
  //   id: "lovable-workflows",
  //   label: "Workflows",
  //   icon: GitBranch,
  //   module: "platform",
  //   path: "/workflows",
  //   action: "view",
  //   isLovable: true,
  //   group: "Platform",
  // },
  // {
  //   id: "lovable-lead-routing",
  //   label: "Lead Routing",
  //   icon: Routes,
  //   module: "platform",
  //   path: "/admin/lead-routing",
  //   action: "view",
  //   isLovable: true,
  //   group: "Platform",
  // },
  // {
  //   id: "lovable-developers",
  //   label: "Developer Portal",
  //   icon: Code2,
  //   module: "platform",
  //   path: "/developers",
  //   action: "view",
  //   isLovable: true,
  //   group: "Platform",
  // },
  // {
  //   id: "lovable-apis",
  //   label: "Open APIs",
  //   icon: Plug,
  //   module: "platform",
  //   path: "/apis",
  //   action: "view",
  //   isLovable: true,
  //   group: "Platform",
  // },
  // {
  //   id: "lovable-compliance",
  //   label: "Compliance",
  //   icon: ShieldCheck,
  //   module: "platform",
  //   path: "/compliance",
  //   action: "view",
  //   isLovable: true,
  //   group: "Platform",
  // },
  // {
  //   id: "lovable-admin",
  //   label: "Admin",
  //   icon: UserCog,
  //   module: "platform",
  //   path: "/admin",
  //   action: "view",
  //   isLovable: true,
  //   group: "Platform",
  // },

  {
    id: "form-config",
    label: "Form Config",
    icon: Package,
    module: "form-config",
    path: "/form-config",
    action: "list",
  },
];
